import { React, useEffect } from "react";
import CardLayout from "../../../components/ReusableComponents/CardLayout";
import DoughnutChart from "../../../components/ReusableComponents/DoughnutChart";
import { ChartCardContent } from "../../dashboard/dashboard.styled";
import { CardWrapper } from "../../apprenticeship/Apprenticeship.styled";
import { toast } from "react-toastify";
import ChartlabelALT from "../../../components/ReusableComponents/ChartlabelALT";
import { CustomDoughnutOptions } from "../../../Constants";
import { useDispatch, useSelector } from "react-redux";
import { updateEduCharts } from "../EducationSlice";
import { fetchChartData } from "../utils";
import PropTypes from "prop-types";

function EducationCharts({customwidth, custommargin,title}) {
	const chartInfo = useSelector((state) => state.education.chart.info);
	const totalValue = useSelector((state) => state.education.chart.totalValue);

	const dispatch = useDispatch();

	useEffect(() => {
		getChartData();
	}, []);

	const chart1Data = {
		labels: ["video(s)", "audio(s)", "book(s)"],
		datasets: [
			{
				label: "resources",
				data: [chartInfo.video, chartInfo.audio, chartInfo.book],
				backgroundColor: ["#006770", "#31A2D3", "#31D98C"],
			},
		],
		totalValue: totalValue.chart1,
	};

	const getChartData = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
			const chartInfo = await fetchChartData();
			if (chartInfo?.result) {
				let result = {
					info: {
						video: chartInfo.result?.video,
						audio: chartInfo.result?.audio,
						book: chartInfo.result?.book,
					},
					totalValue: {
						chart1: chartInfo.result?.video + chartInfo.result?.audio + chartInfo.result?.book,
						// chart2: chartInfo.result?.customersPerTime + chartInfo.result?.totalCustomers,
					},
				};
				//update state here
				dispatch(updateEduCharts(result));
			}
		} catch (error) {
			console.log(error);
			toast.error("unable to fetch charts data");
		}
	};

	return (
		<CardWrapper customwidth={customwidth}
		custommargin={custommargin}
		>
			<CardLayout type={title}>
				<ChartCardContent firstcolor='#0091BF' secondcolor='#BAD8D4'>
					<DoughnutChart
						totalAmount={totalValue.chart1}
						data={chart1Data}
						options={CustomDoughnutOptions}
					/>
					<ChartlabelALT
						firstColorId={"#006770"}
						firstCaption={"Video"}
						firstAmount={chartInfo?.video}
						secondColorId={"#31A2D3"}
						secondCaption={"Audio"}
						secondAmount={chartInfo?.audio}
						thirdColorId={"#31D98C"}
						thirdCaption={"Book"}
						thirdAmount={chartInfo?.book}
						totalAmount={totalValue.chart1}
						customLabel={"resource(s)"}
					/>
				</ChartCardContent>
			</CardLayout>
		</CardWrapper>
	);
}
EducationCharts.propTypes = {
	customwidth: PropTypes.string,
	custommargin: PropTypes.string,
	title:PropTypes.string,
};

export default EducationCharts;
